(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var LOOP = true; // set to false to stop at first/last instead of wrapping

    function init() {
      var gallery = document.querySelector('[data-gallery]');
      if (!gallery) return;

      var images = gallery.querySelectorAll('.product-detail__main-img');
      var thumbs = document.querySelectorAll('[data-gallery-thumb]');
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');

      if (images.length < 2) return;

      var current = 0;
      var total = images.length;

      function setActive(index) {
        if (LOOP) {
          index = (index + total) % total;
        } else {
          index = Math.max(0, Math.min(total - 1, index));
          if (index === current) return;
        }
        for (var i = 0; i < images.length; i++) {
          images[i].classList.toggle('is-active', i === index);
        }
        for (var j = 0; j < thumbs.length; j++) {
          thumbs[j].classList.toggle('is-active', j === index);
        }
        current = index;
      }

      if (prev) prev.addEventListener('click', function () { setActive(current - 1); });
      if (next) next.addEventListener('click', function () { setActive(current + 1); });

      for (var k = 0; k < thumbs.length; k++) {
        (function (idx) {
          thumbs[idx].addEventListener('click', function () { setActive(idx); });
        })(k);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
